/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ElektronischeZustellungKontaktDto } from '../../models/elektronische-zustellung-kontakt-dto';

export interface EmployeeControllerGetMultipleEmployeeEmailsPhones$Params {
  ids: Array<number>;
}

export function employeeControllerGetMultipleEmployeeEmailsPhones(http: HttpClient, rootUrl: string, params: EmployeeControllerGetMultipleEmployeeEmailsPhones$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ElektronischeZustellungKontaktDto>>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerGetMultipleEmployeeEmailsPhones.PATH, 'get');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ElektronischeZustellungKontaktDto>>;
    })
  );
}

employeeControllerGetMultipleEmployeeEmailsPhones.PATH = '/api/employee/employee-email-phone';
